import { api } from '@/api';
import {
  type BookingDTO,
  type SendTicketDeliveryV2RequestDTO,
} from '@/types/dto/agent';

export const fetchInitiateRefund = async (
  bookingId: BookingDTO['id'],
  fulfillmentIds: Array<string>
) => {
  if (!bookingId) {
    return null;
  }

  const response = await api.agentApi.RefundOffers_InitiateRefund(
    { bookingId },
    { fulfillmentIds }
  );

  return response.data;
};

export const fetchSendTicketsToEmail = async (
  request: SendTicketDeliveryV2RequestDTO
) => {
  const response = await api.agentApi.Notifications_SendTicketDeliveryV2(
    null,
    request
  );

  return response.data;
};
